import { create } from "zustand";
import axiosInstance from "../lib/axios";

export const useNotificationStore = create((set, get) => ({
  unreadCount: 0,
  loading: false,
  error: null,

  getUnreadCount: async () => {
    try {
      set({ loading: true, error: null });
      const response = await axiosInstance.get("/messages/unread/count");
      set({ unreadCount: response.data.count });
    } catch (error) {
      set({ error: "Failed to fetch unread count" });
      console.error("Error fetching unread count:", error);
    } finally {
      set({ loading: false });
    }
  },

  markAsRead: async () => {
    try {
      await axiosInstance.post("/messages/read");
      const response = await axiosInstance.get("/messages/unread/count");
      set({ unreadCount: response.data.count });

    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  },

  incrementUnreadCount: () => {
    set((state) => ({ unreadCount: state.unreadCount + 1 }));
  },

  resetUnreadCount: () => {
    set({ unreadCount: 0 });
  },
})); 